import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Offer } from './offer.resource';
import { NumberFilter, StringFilter } from 'src/app/filter/filter';
import { AtomService } from '../atom.service';
import {
  ResourceConfig,
  ResourceConfigOne,
  ResourceConfigTab,
} from 'src/app/resources/resources-interfaces/resource-config';

@Resource({
  type: 'creditsetups',
})
export class CreditSetup extends AtomResource {
  @Attribute() name?: string;
  @Attribute({ key: 'credit_on_registration' }) creditOnRegistration?: number;
  @Attribute({ key: 'credit_on_invoice' }) creditOnInvoice?: number;
  @Attribute() tld?: string;

  @Relationship() offers?: Offer[];
}

export class CreditSetupConfig implements ResourceConfig {
  tables = {
    includes: [],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main', translatable: false }],
        header: 'ID',
        translatable: false,
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'name',
        displayedDatas: [
          {
            path: ['name'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'Name',
        displayed: true,
        sort: 'name',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'creditOnRegistration',
        displayedDatas: [
          {
            path: ['creditOnRegistration'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'Credit On Registration',
        sort: 'creditOnRegistration',
        displayed: true,
      },
      {
        columnDef: 'creditOnInvoice',
        displayedDatas: [
          {
            path: ['creditOnInvoice'],
            class: 'mat-body-2',
            translatable: true,
          },
        ],
        header: 'Credit On Invoice',
        sort: 'creditOnInvoice',
        displayed: true,
      },
      {
        columnDef: 'offers',
        header: 'Offers',
        displayed: true,
        link: {
          resource: 'offers',
          list: 'offers',
          target: 'creditsetup',
        },
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail: ResourceConfigOne = {
    header: {
      icon: 'credit_card',
      title: [
        {
          path: ['id'],
          translatable: false,
        },
        {
          path: ['name'],
          translatable: false,
        },
      ],
    },
    elements: [
      {
        showEmpty: true,
        columns: false,
        list: [
          {
            icon: 'credit_card',
            title: 'Credit On Registration',
            APIKey: 'creditOnRegistration',
            value: {
              path: ['creditOnRegistration'],
              translatable: false,
            },
          },
          {
            icon: 'credit_card',
            title: 'Credit On Invoice',
            APIKey: 'creditOnInvoice',
            value: {
              path: ['creditOnInvoice'],
              translatable: false,
            },
          },
          {
            icon: 'local_offer',
            title: 'Offers',
            APIKey: 'offers',
            link: {
              resource: 'offers',
              list: 'offers',
              target: 'creditsetup',
            },
          },
        ],
      },
    ],
  };
  wizard: {
    tabs?: ResourceConfigTab[];
    linear?: boolean;
  } = {
    tabs: [
      {
        title: 'Main Settings',
        formGroup: 'main',
        list: [
          {
            type: 'text',
            title: 'Name',
            formControl: 'name',
            APIKey: 'name',
            translatable: false,
            required: true,
          },
          {
            type: 'text',
            title: 'Credit On Registration',
            formControl: 'creditOnRegistration',
            APIKey: 'creditOnRegistration',
            translatable: false,
          },
          {
            type: 'text',
            title: 'Credit On Invoice',
            formControl: 'creditOnInvoice',
            APIKey: 'creditOnInvoice',
            translatable: false,
          },
        ],
      },
    ],
  };
  resource = CreditSetup;
  resourceName = 'Credit Setup';
  resourceKey = 'creditsetups';
  resourceKeySingle = 'creditsetup';
  includes = [];
  filters = [
    new NumberFilter('id', 'ID', true),
    new StringFilter('name', 'Name'),
    new NumberFilter('offers.id', 'Offer ID'),
    new StringFilter('offers.name', 'Offer NAME'),
  ];
  constructor(private atom: AtomService) {}
}
